<template>
  <v-card elevation="0" class="all-trade-tab rounded-0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <ConditionOneTab></ConditionOneTab>
  </v-card>
</template>
<script>
import ConditionOneTab from './ConditionOneTab.vue';
export default {

  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    ConditionOneTab
  },
};
</script>
